import styled from 'styled-components';

export const StyledAddAttendanceModal = styled.div`
  padding: 12px 36px 0;
  max-height: 60vh;
  min-height: 40vh;
  overflow-y: auto;
  padding-bottom: 20px;

  .aa-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .aa-table {
    max-height: 400px;
    overflow-y: auto;

    > div {
      > .MuiTableContainer-root {
        max-height: calc(400px - 60px);
      }
    }
  }

  div.groupWrapper {
    display: flex;
    justify-content: space-between;
  }

  div.attend-table {
    margin-top: 20px;
    .MuiPaper-root {
      display: flex;
      justify-content: end;
      width: 770px;
    }
  }

  div.buttonGroup {
    display: flex;
    justify-content: flex-end;
  }
`;
